import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'
import { useRemovePatientFromQueueMutation } from '@/core/services/patient-queue'
import { getApiErrorMessage } from '@/utils/errors'

export function useRemoveQueuedPatient() {
  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation()

  const [removePatientFromQueue, { isLoading: isRemoving }] = useRemovePatientFromQueueMutation()

  const removeQueuedPatient = async (patientId: string) => {
    try {
      await removePatientFromQueue(patientId).unwrap()
      enqueueSnackbar(t`Patient has been removed successfully from the queue`, { variant: 'success' })
    } catch (error) {
      enqueueSnackbar(getApiErrorMessage(error, t`An error occurred while removing the patient from the queue`), { variant: 'error' })
    }
  }

  return [removeQueuedPatient, isRemoving] as const
}
